import { HStack, Icon, VStack } from "@/shared/ui/primitives";
import { useTranslation } from "react-i18next";

export interface UserCardProps {
	plan: string;
	email: string;
	onLogout: () => void;
}

export const UserCard = (p: UserCardProps) => {
	const { t } = useTranslation();

	return (
		<HStack className="w-full px-[20px] py-[16px] rounded-[20px] gap-[10px] border border-outline bg-bg-weak/80 backdrop-blur-sm shadow-[0_8px_32px_rgba(15,23,42,0.06)]">
			<VStack className="w-full gap-[2px]">
				<span className="w-full text-sm text-pm-strong font-normal">
					{p.plan} {t("user.plan")}
				</span>
				<span className="w-full text-md text-ct-strong font-medium">{p.email}</span>
			</VStack>
			<button
				onClick={p.onLogout}
				className="p-[10px] rounded-[10px] bg-bg-regular text-ct-regular shrink-0"
			>
				<Icon name="Logout" />
			</button>
		</HStack>
	);
};
